// extracted by mini-css-extract-plugin
export default {"Cars":"Cars_Cars__YlAr3","Cars__new":"Cars_Cars__new__jLKsZ"};